import React from "react";
import axios from "axios";
import apiUrl from "../../apiUrlConstant";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faPen,
  faTimes,
  faSearch,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../masters/master.css";
import Select from "react-select";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { Modal, Button } from "react-bootstrap";
// import { PdfReader } from "../../utils/DocumentViewer";
import { ViewLeasePdfReader } from "../../utils/ViewLeaseDocumentViewer";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";

import * as Yup from "yup";
import { type } from "jquery";

const prospectFilterForm = Yup.object().shape({
  //assetType: Yup.string().required("Required"),
  //city: Yup.string().required("Required"),
  //brandCategory: Yup.string().required("Required"),
  assetName: Yup.string().required("Required"),
  floor: Yup.string().required("Required"),
  //rangeFrom: Yup.string().required("Required"),
  //rangeTo: Yup.string().required("Required"),
});

const prospectValidation = Yup.object().shape({
  landlordAssetId: Yup.string().required("Required"),
  //gla: Yup.string().required("Required"),
});

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

const prospectObj = {
  project_id: "",
  broking_by: "",
  broking_type: "",
  broker_name: "",
  landlordAssetName: "",
  "19_36_months": "",
  address: "",
  agreement_type: "",
  automated_daily_sales_report_adsr: "",
  brand_name: "",
  cam_charges: "",
  cam_commencement_date: "",
  cam_escalation: "",
  cancellation_and_termination: "",
  carpet_area: "",
  confidentiality: "",
  delay_in_commencement_licensee: "",
  delay_in_scheduled_date_proposed_licensee: "",
  eligibility_under_laws: "",
  escalation_on_monthly_lease_rental: "",
  extension_of_term_renewal_term: "",
  first_month_18th_month: "",
  franchisee_by_party2: "",
  governing_law_and_jurisdiction: "",
  gst_and_other_taxes_surcharges_levies_etc: "",
  handover_date: "",
  ifrm_sd_amount: "",
  ifrm_sd_cam_deposit_escalation: "",
  ifrm_sd_cam_deposit_for_company_name: "",
  ifrm_sd_instalment_1: "",
  ifrm_sd_instalment_2: "",
  ifrm_sd_instalment_3: "",
  ifrm_sd_months: "",
  ifrm_sd_payment_schedule: "",
  ifrm_sd_rate: "",
  ifrsd_amount: "",
  ifrsd_months: "",
  ifrsd_payment_schedule: "",
  ifrsd_rate: "",
  ifrsd_rent_deposit_escalation: "",
  ifrsd_rent_deposit_for_company_name: "",
  industry_of_party2: "",
  instalment_1: "",
  instalment_2: "",
  instalment_3: "",
  insurance: "",
  lease_commencement_date: "",
  lessee: "",
  lessor: "",
  lock_in_period_for_party_2: "",
  loi_issue_date: "",
  monthly_fixed_rental_or_revenue_share: "",
  monthly_lease_rental_logic_basis: "",
  monthly_lease_rental_rent_commencement_date: "",
  monthly_variable_rental_revenue_share: "",
  nature_of_party2: "",
  other_charges_for_the_permitted_business: "",
  parking: "",
  party_2_details: "",
  party_2_kyc_details: "",
  payment_mechanism_charges: "",
  pre_fit_out_handover_requirements: "",
  property_tax: "",
  rent_free_fit_out_period_from_handover_date: "",
  representations_and_warranties: "",
  signage: "",
  stamp_duty_and_registration_charges: "",
  super_area: "",
  term: "",
  to_be_completed_by_party1: "",
  to_be_completed_by_party2: "",
  unit_details: "",
  utilities: "",
  utility_charges_commencement_date: "",
  validity_of_loi: "",
};

class Prospect extends React.Component {
  mainFormValidator = [];

  state = {
    redirect: false,
    id: undefined,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    popupalertMessage: false,
    popupMessageContent: "",
    prospectFields: [],
    url: `${apiUrl.apiUrl.url}/prospect/create`,
    assetNames: [],
    unitLists: [],
    unitListSelected: [],
    unitListSelectedValue: [],
    initialValues: {},
    prospectInitialValues: prospectObj,
    isDisabled: false
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }
  componentDidMount() {
    this.fetchAsset();
    this.fetchProspectFields();
  }

  componentDidUpdate() {
    var self = this;
    if (this.props.match.params.id != this.state.id) {
      this.state.id = this.props.match.params.id;

      if (this.props.match.params.id === undefined) {
        this.setState({
          url: `${apiUrl.apiUrl.url}/prospect/create`,
          prospectInitialValues: prospectObj,
        });
      } else {
        this.state.isDisabled = true;

        axios.get(`${apiUrl.apiUrl.url}/prospect/fetch-prospect?id=${this.props.match.params.id}`).then(function (response) {
          let data = response.data;
          self.setState({
            url: `${apiUrl.apiUrl.url}/prospect/update?id=${self.props.match.params.id}`,
            prospectInitialValues: data,
          });
          
          this.fetchUnits(data.project_id);
           //  const unitDetails = data.unit_details && data.unit_details.trim() !== "" ? data.unit_details.split(",") : [];
          const unitDetails = data.unit_lists ? data.unit_lists : [];
          this.state.unitListSelectedValue = data.unit_details;
          this.state.unitListSelected = [];
          if(unitDetails.length > 0) {
            unitDetails.forEach((item) => {
              this.state.unitListSelected.push({
                value: item.value,
                label: item.label
              });
            });
          }

          self.setState({});
        });

        // fetch(
        //   `${apiUrl.apiUrl.url}/prospect/fetch-prospect?id=${this.props.match.params.id}`
        // )
        //   .then((response) => {
        //     return response.json();
        //   })
        //   .then((data) => {
        //     self.setState({
        //       url: `${apiUrl.apiUrl.url}/prospect/update?id=${self.props.match.params.id}`,
        //       prospectInitialValues: data,
        //     });
            
        //     this.fetchUnits(data.project_id);
        //      //  const unitDetails = data.unit_details && data.unit_details.trim() !== "" ? data.unit_details.split(",") : [];
        //     const unitDetails = data.unit_lists ? data.unit_lists : [];
        //     this.state.unitListSelectedValue = data.unit_details;
        //     this.state.unitListSelected = [];
        //     if(unitDetails.length > 0) {
        //       unitDetails.forEach((item) => {
        //         this.state.unitListSelected.push({
        //           value: item.value,
        //           label: item.label
        //         });
        //       });
        //     }

        //     self.setState({});
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });


          self.setState({});
      }
    }
  }

  fetchProspectFields() {
    fetch(`${apiUrl.apiUrl.url}/prospect/fetch-prospect-fields`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          prospectFields: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeAsset = (e, i) => {
    this.state.prospectInitialValues.landlordAssetName = e.label;
    this.state.prospectInitialValues.project_id = e.value;

    this.state.unitListSelected = [];
    this.fetchUnits(e.value);

    this.setState({});
    console.groupEnd();
    this.setState({});
  };

  fetchUnits = (assetId) =>{
    fetch(`${apiUrl.apiUrl.url}/asset/fetch-unit-list-by-asset-id?id=${assetId}`, { headers })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      this.setState({
        unitLists: data,
      });
    })
    .catch((error) => {
      console.log(error);
    });

    this.setState({});
  }

  changeUnitAsset = (newValue) => {
    console.log(newValue);
    this.state.unitListSelected = [];
    this.state.unitListSelectedValue = [];
    for (let i = 0; i < newValue.length; i++) {
      this.state.unitListSelectedValue.push(newValue[i].value);
      this.state.unitListSelected.push({
        value: newValue[i].value,
        label: newValue[i].label,
      });
    }

    this.setState({});
  };

  fetchAsset = () => {
    fetch(`${apiUrl.apiUrl.url}/asset/fetch-all-assets`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetNames: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  redirectToClose = () => {
    this.setState({
      popupalertMessage: false,
      popupMessageContent: "",
    });
  };

  render() {
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }
  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });
  renderForm() {
    return (
      <div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>
        <Formik
          initialValues={this.state.prospectInitialValues}
          enableReinitialize
          //validationSchema={prospectValidation}
          onReset={(values, actions) => {
            for (const [key, value] of Object.entries(
              this.state.prospectInitialValues
            )) {
              //this.state.prospectInitialValues[key] = "";
            }
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            if (!this.mainFormValidator.allValid()) {
              this.mainFormValidator.getErrorMessages();
              this.mainFormValidator.showMessages();
              //this.forceUpdate(); 
              return false;
            }
            var self = this;
            values.project_id = this.state.prospectInitialValues.project_id;
            values.unit_details = Array.isArray(this.state.unitListSelectedValue) && this.state.unitListSelectedValue.length > 0 ? this.state.unitListSelectedValue.join(", ") : "";
            axios({
              method: "post",
              //url: `${apiUrl.apiUrl.url}/prospect/create`,
              url: this.state.url,
              data: values,
            }).then(function (response) {
              if (!response.data.success) {
                // alert("Something went wrong");
                self.setState({
                  popupalertMessage: true,
                  popupMessageContent: "Something went wrong",
                });
                actions.setSubmitting(false);

                actions.setErrors(response.data);
              } else {
                for (const [key, value] of Object.entries(
                  self.state.prospectInitialValues
                )) {
                  self.state.prospectInitialValues[key] = "";
                  self.setState({});
                }
                for (const [key, value] of Object.entries(
                  self.state.initialValues
                )) {
                  self.state.initialValues[key] = "";
                  self.setState({});
                }
                //self.state.comparativeData = [];
                self.setState({});

                // self.setState({ redirect: true });
                // alert("Data Saved successfully.");
                self.setState({
                  messsagePopup: true,
                });

                self.props.history.push(
                  "/createlease/prospect/view/" + response.data.id
                );
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            setFieldValue,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off" >
                <div className="newGridSectionParent bg-transparent">
                  <div className="tableContainer prospectTable bg-white">
                    <table className="table tableSimple tableSimpleWithNoFlex">
                      <thead>
                        <tr>
                          <th scope="col">Field Name</th>
                          <th scope="col">Prospect</th>
                          <th scope="col">Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <h6>NAME OF THE PROJECT <span className="astrik">*</span></h6>
                          </td>
                          <td>
                            <div className="position-relative">
                              <Select
                                className="basic-single custom-select-style"
                                classNamePrefix="custom-select-style-inner"
                                // menuIsOpen={true}
                                isSearchable="true"
                                isDisabled={this.state.isDisabled}
                                name="project_id"
                                value={{
                                  label: this.state.prospectInitialValues.landlordAssetName,
                                  value: this.state.prospectInitialValues.project_id,
                                }}
                                onChange={(e) => {
                                  this.changeAsset(e);
                                }}
                                options={this.state.assetNames.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />
                              {this.mainFormValidator.message(
                                "Project",
                                this.state.prospectInitialValues.project_id,
                                "required",
                                { className: "text-danger bgWhite" }
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="position-relative">
                            
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>Unit(s), Floor & Location</h6>
                          </td>
                          <td>
                            {/* <Field
                              type="text"
                              name="unit_details"
                              className="tdInput"
                            /> */}

                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="unit_details"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.changeUnitAsset(e);
                            }}
                            value={this.state.unitListSelected}
                            options={this.state.unitLists.map((item) => ({
                              label: item.unit_no,
                              value: item.id,
                            }))}
                          />

                            <ErrorMessage
                              name="unit_details"
                              component="div"
                              className="text-red"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>Carpet Area of Unit</h6>
                          </td>
                          <td>
                            <Field
                              type="text"
                              name="carpet_area"
                              className="tdInput"
                            />
                            <ErrorMessage
                              name="carpet_area"
                              component="div"
                              className="text-red"
                            />
                          </td>
                          <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['carpet_area']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>
                              Super Area (chargeable Area)* Of The Unit(s)
                            </h6>
                          </td>
                          <td>
                            <Field
                              type="text"
                              name="super_area"
                              className="tdInput"
                            />
                            <ErrorMessage
                              name="super_area"
                              component="div"
                              className="text-red"
                            />
                          </td>
                          <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['super_area']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>Address Of The Project <span className="astrik">*</span></h6>
                          </td>
                          <td>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="address"
                                className="tdInput"
                              />
                              {this.mainFormValidator.message(
                                "address",
                                values.address,
                                "required",
                                { className: "text-danger bgWhite" }
                              )}
                            </div>
                          </td>
                          <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['address']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>Broking By</h6>
                          </td>
                          <td>
                            <Field
                              as={"select"}
                              //value='broking_type'
                              name={"broking_by"}
                              onChange={(e) => {
                                this.state.prospectInitialValues.broking_by = e.target.value;
                                this.setState({});
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              {["Direct", "Broker"].map((obj) => (
                                <option key={obj} value={obj}>
                                  {obj}
                                </option>
                              ))}
                            </Field>
                          </td>
                          <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['broking_by']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <h6>Broker Name</h6>
                          </td>
                          <td>
                            <Field
                              type="text"
                              name="broker_name"
                              className="tdInput"
                            />
                          </td>
                          <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['broker_name']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                        </tr>
                        {
                          this.state.prospectInitialValues.broking_by == "Broker" && (
                            <tr>
                              <td>
                                <h6>Broking Type</h6>
                              </td>
                              <td>
                                <Field
                                  as={"select"}
                                  //value='broking_type'
                                  name={"broking_type"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  {["IPC", "Local"].map((obj) => (
                                    <option key={obj} value={obj}>
                                      {obj}
                                    </option>
                                  ))}
                                </Field>
                              </td>
                              <td>
                            <div className="position-relative">
                            <Field
                              type="text"
                              name={`additional_notes['main']['broking_type']`}
                              className="tdInput"
                            />
                            </div>
                          </td>
                            </tr>
                          )
                        }

                      </tbody>
                    </table>
                  </div>
                  <Accordion defaultActiveKey="0">
                    {this.state.prospectFields.map((section, index) => (
                      <div key={index}>
                        <div className="prospectAccordion">
                          {/* <div className="col-lg-12 p-0"> */}

                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>{section.title}</Accordion.Header>
                            <Accordion.Body>
                              <div className="tableContainer prospectTable mt-0">
                                <table className="table tableSimple tableSimpleWithNoFlex">
                                  {section.form_fields.map(
                                    (topSection, topIndex) => (
                                      <>
                                        {topSection.sub_title && (
                                          <thead>
                                            <tr>
                                              <th scope="col" colSpan="2">
                                                {topSection.sub_title}
                                              </th>
                                              <th>Notes</th>
                                            </tr>
                                          </thead>
                                        )}
                                        {topSection.fields.map((field, i) => (
                                          <tbody>
                                            <tr>
                                              <td>
                                                <h6>{field.title}</h6>
                                              </td>

                                              <td>
                                                <Field
                                                  key={field.name}
                                                  type="text"
                                                  name={
                                                    typeof field.additional_info === "undefined"
                                                      ? field.name
                                                      : `additional_info[${field.section}][${field.name}]`
                                                  }
                                                  className="tdInput"
                                                />
                                              </td>
                                              
                                              <td>
                                                <div className="position-relative">
                                                  <Field
                                                    type="text"
                                                    name={
                                                      typeof field.additional_info === "undefined"
                                                        ? `additional_notes['main'][${field.name}]`
                                                        : `additional_notes[${field.section}][${field.name}]`
                                                    }
                                                    className="tdInput"
                                                  />
                                                </div>
                                              </td>
                                              
                                            </tr>
                                          </tbody>
                                        ))}
                                      </>
                                    )
                                  )}
                                  <tbody></tbody>
                                </table>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>

                          {/* </div> */}
                        </div>
                      </div>
                    ))}
                  </Accordion>
                  <div className="container mt-3">
                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer formSubmit">
                          <div>
                            <button type="submit">
                              Save Draft
                            </button>
                            <button type="reset">
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        <div className="row">
          <div className="col-lg-12">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              size="lg"
              className="documentModal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <div className="container modalBreadCrumbs">
                    <div className="row">
                      <div className="col-lg-12">
                        <ul>
                          <li>Document</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="container">
                  <div className="row">
                    <ViewLeasePdfReader
                      url={this.state.currentDocument}
                      pageNumber={this.state.pageNo}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Prospect);
